module.exports = __webpack_public_path__ + "img/64.aecc9585.jpg";